import React, { Component } from 'react';
import Hero from "../modules/Hero/Hero";
import SecondHeading from "../modules/SecondHeading";
import ThreeColumnIcons from "../modules/ThreeColumnIcons/ThreeColumnIcons";
import globals from '../globals';
import PartnersForm from "../forms/PartnersForm/PartnersForm";
import HelmetDefault from "../layout/HelmetDefault";

class Partners extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
            leadCopy: [],
            secondHeading: {},
            threeColumn: {},
            seoTitle: '',
            seoDescription: '',
            dataReceived: false
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        fetch('/api/partners')
            .then(result => result.json())
            .then((result) => {
                this.setState(result);
                this.setDataReceived();
                globals.animatePageIn(this.container);
            });
    }

    setDataReceived() {
        this.setState({
            dataReceived: true
        });
    }

    render() {
        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}}>
                <HelmetDefault {...this.state} />
                <Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived} />
                <SecondHeading data={this.state.secondHeading} />
                <ThreeColumnIcons data={this.state.threeColumn} dataReceived={this.state.dataReceived} />
                <PartnersForm />
            </div>
        );
    }

}

export default Partners;


// WEBPACK FOOTER //
// ./resources/assets/js/pages/Partners.js